module.exports = __webpack_public_path__ + "img/7.e44078c4.png";